import { parse, stringify } from 'query-string';

/**
 * Calculate offset based on current page
 * and set limit
 * @param {number} page
 * @param {number} limit
 * @returns {number} offset
 */
export function getOffsetFromPage(page, limit) {
    let offset;

    if (page > 1) {
        offset = (page - 1) * limit;
    } else {
        offset = 0;
    }

    return offset;
}

/**
 * Calculate total number of pages from limit and total
 * @param {number} total
 * @param {number} limit
 * @returns number
 */
export function getPageTotalCount(total, limit) {
    return Math.ceil(total / limit);
}

/**
 * Builds a new query string based on curent string
 * and new reviewPage value
 * @param {number} reviewPage page number to be changed in query string
 * @returns queryString
 */
export function buildReviewPageQS(reviewPage) {
    let newParams = parse(window.location.search);
    let qs;

    if (reviewPage && reviewPage > 1) {
        newParams.reviewPage = reviewPage;
    } else {
        delete newParams.reviewPage;
    }

    qs = stringify(newParams);

    return qs;
}

/**
 * Updates the URL (without a page reload) based on the review page
 * @param {number} reviewPage page number to be changed in query string
 */
export function updateReviewPageParam(reviewPage) {
    let qs = buildReviewPageQS(reviewPage);

    // Add a ? to the query string if it is defined
    if (qs) {
        qs = `?${qs}`;
    }

    const newUrl = window.location.origin + window.location.pathname + qs;

    history.replaceState({}, 'update review page param', newUrl);
}

/**
 * Takes an average fit value decimal 1-5 and maps it to a given fit rating's value
 * For example: 1-1.80 will return 1, 1.81-2.6 will return 2, etc
 * @param value average fit rating value
 */
export function mapAverageFitValue(averageFitValue) {
    return Math.max(Math.ceil(((averageFitValue - 1) * 5) / 4), 1);
}

export default {
    getOffsetFromPage,
    getPageTotalCount,
    buildReviewPageQS,
    updateReviewPageParam,
    mapAverageFitValue
};
